import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { infoCards } from "../data/whoWeAreData";
import BesnikT from "../assets/images/BesnikT.jpeg";
import InfoCard from "../components/InfoCard";
import CoreTopics from "../components/CoreTopics";

const WhoWeAre = () => {
  const [expandedId, setExpandedId] = useState(null);
  const navigate = useNavigate();

  const handleToggle = (id) => {
    setExpandedId((prev) => (prev === id ? null : id)); // If the same card is clicked, collapse it
  };

  return (
    <section
      id="who-we-are"
      className="relative py-24 xs:py-12 xxs:py-12 px-6 xs:px-8 xxs:px-8 md:px-12 md:py-[3rem] bg-brandBlue text-white font-outfit overflow-hidden"
    >
      <div className="max-w-6xl mx-auto relative z-10">
        <h3 className="text-[1.3125rem] text-center xxs:text-lg xs:text-lg xxs:mb-[1.5rem] xs:mb-[1.5rem] leading-[1.3125rem] mb-[3rem] uppercase tracking-[0.2em] font-normal text-white">
          Who We Are
        </h3>

        <div className="text-sm md:text-xl  max-w-[76%] xs:max-w-full xxs:max-w-full flex flex-col gap-[2rem]  leading-relaxed">
          <p>
            The International Governance Conference (IGC) is a premier annual
            global forum dedicated to addressing contemporary governance
            challenges and promoting effective, transparent, and sustainable
            governance practices. Held in Tirana, Albania, during the second
            week of September, the Conference brings together senior government
            officials, policymakers, international organizations, business
            leaders, academics, and civil society representatives from across
            the globe. Founded in 2025 by Besnik Tahiri, the IGC serves as a
            high-level platform for thought- provoking dialogue, collaboration,
            and the exchange of innovative ideas and governance models. The
            Conference emphasizes both open public discussions and private,
            candid conversations under the Chatham House Rule to ensure
            constructive and solution-oriented engagement.
          </p>
          <p>
            Through open-door plenary sessions, candid discussions, and keynote
            speeches, we aim to foster collaboration and drive impactful
            solutions for global governance
          </p>
        </div>
        <div className="relative pl-5 border-l-[4px] mt-10 border-transparent">
          <div className="absolute inset-y-0 left-0 w-1 bg-gradient-to-b from-[#00f78f] to-softGreen rounded-sm" />
          <p className="font-semibold text-lg text-[#B8EAE4] ml-2 mb-6">
            Effective governance is the cornerstone of sustainable development
            and global stability
          </p>
          <div
            onClick={() => navigate("/speakers/besnik-tahiri")}
            className="flex cursor-pointer items-center gap-4"
          >
            <img
              src={BesnikT}
              alt="Besnik Tahiri"
              className="w-12 h-12 rounded-full object-cover"
            />
            <div>
              <p className="font-semibold">Besnik Tahiri</p>
              <p className="text-[#4C7C7D] text-sm">
                Founder, International Governance Conference
              </p>
            </div>
          </div>
        </div>

        <div className="grid gap-8 sm:grid-cols-2 text-center lg:grid-cols-4 mt-12">
          {infoCards.map((card) => (
            <InfoCard
              key={card.id}
              icon={card.icon}
              title={card.title}
              shortDescription={card.shortDescription}
              longDescription={card.longDescription}
              isExpanded={expandedId === card.id}
              onToggle={() => handleToggle(card.id)}
            />
          ))}
        </div>
        <CoreTopics />
      </div>
      <div className="absolute top-[-100px] left-[-100px] w-[300px] h-[300px] bg-softGreen/30 blur-3xl rounded-full z-0" />
      <div className="absolute bottom-[-100px] right-[-100px] w-[300px] h-[300px] bg-brandGreen/20 blur-3xl rounded-full z-0" />
    </section>
  );
};

export default WhoWeAre;
